export default __webpack_public_path__ + "static/media/news2.b2bde151.png";